import pusher from '../../../helpers/PusherManager'
import LifeStyleApi from '../../../api/LifeStyle';
import config from '../../../config'

export default {
  data () {
    return {
      isCommentsLoading: true,
      isCommentsComplete: false,
      addCommentModel: {
        message: '',
      },
      commentParams: {},
      commentFilters: [
        {label: "Most Popular", model: "MOST_POPULAR"},
        {label: "Most Recent", model: "MOST_RECENT"},
        {label: "Most Replies", model: "MOST_REPLIES"},
      ],
      isAddingComment: false,
      comments: []
    }
  },
  mounted () {
    let self = this;
    self.isCommentsLoading = true;
    self.isCommentsComplete = false;
    self.commentParams = self.pageDefaults();
    self.initPusherCalls(self.postId);
    self.loadPostComments(self.postId);
   },
  computed: {
    isAdmin() {
      let self = this;
      return self.$store.state.user.user_role.role_id === 2;
    }
  },
  methods: {
    getInitialsFromName(name, delimeter) {
      if (name) {
        let array = name.split(delimeter);
        switch (array.length) {
          case 1:
            return array[0].charAt(0).toUpperCase();
            break;
          default:
            return array[0].charAt(0).toUpperCase() + array[array.length - 1].charAt(0).toUpperCase();
        }
      }
      return false;
    },
    containsAvatarMed(string, hasString) {
      return string && string.includes(hasString);
    },
    fromNow (date) {
      return config.dateFormatting.fromNow(date);
    },
    initPusherCalls(post_id) {
      let self = this, params = self.$route.params;
      const userId = self.$store.state.user.scope.user_id;
      const channel = pusher.subscribe('post_' + post_id);
      // add comment
      channel.bind('comment_added', (data) => {
        if (data.level === 0) {
          data.comment.editcomment = false;
          data.comment.edit_comment = data.comment.comment;
          self.comments.splice(0, 0, data.comment);
          self.commentParams.totalComments = data.commentsCount;
        } else if (data.level === 1) {
          const length = self.comments.length;
          for (let i = 0; i < length; i++) {
            if (self.comments[i].comment_id === data.comment.comment_id) {
              data.comment.edit_comment = data.comment.comment;
              data.comment.editcomment = false;
              self.comments[i].replies.splice(0, 0, data.comment);
              self.comments[i].reply_count++;
            }
          }
        }
      });

      // like comment
      channel.bind('comment_liked', (data) => {
        if (data.level === 0) {
          if (data.status) {
            (data.user_id === userId) ? self.comments[data.index].likes.liked = true : '';
            self.comments[data.index].total_likes++;
          } else {
            (data.user_id === userId) ? self.comments[data.index].likes.liked = false : '';
            self.comments[data.index].total_likes--;
          }
        } else if (data.level === 1) {
          let replies = self.comments[data.parenti].replies[data.index];
          if (data.status) {
            (data.user_id === userId) ? replies.likes.liked = true : '';
            replies.total_likes++;
          } else {
            (data.user_id === userId) ? replies.likes.liked = false : '';
            replies.total_likes--;
          }
        }
      });

      // edit comment
      channel.bind('comment_edited', (data) => {
        if (data.level === 0) {
          self.comments[data.index].comment = data.comment;
        } else if (data.level === 1) {
          self.comments[data.parenti].replies[data.index].comment = data.comment;
        }
      });

      // delete comment
      channel.bind('comment_deleted', (data) => {
        if (data.level === 0) {
          self.comments.splice(data.index, 1);
          self.commentParams.totalComments = data.commentsCount;
        } else if (data.level === 1) {
          self.comments[data.parenti].replies.splice(data.index, 1);
          self.comments[data.parenti].reply_count--;
        }
      });
    },
    loadPostComments (post_id) {
      let self = this;
      self.isCommentsLoading = true;
      self.commentParams.post_id = post_id;
      LifeStyleApi.getPostComments(self.commentParams).then((response) => {
        let data = response.data;
        // top level comments
        _.mapValues(data.comments, function (val) {
          val.new_comment = "";
          val.edit_comment = val.comment;
          val.editcomment = false;
          val.show = false;
          return val;
        });
        // map values to sub replies
        (data.comments).forEach((comment) => {
          _.mapValues(comment.replies, function (val) {
            val.new_comment = "";
            val.edit_comment = val.comment;
            val.editcomment = false;
            val.show = false;
            return val;
          });
        });
        self.commentParams.totalComments = data.comments_count;
        if (self.commentParams.page === 1) {
          self.comments = data.comments;
        } else {
          self.comments.push.apply(
            self.comments,
            data.comments
          );
        }
        if (data.comments.length === 0) {
          self.isCommentsComplete = true;
        } else {
          self.commentParams.page += 1;
        }
        self.isCommentsLoading = false;
      }).catch(error => {
        self.isCommentsLoading = false;
      });
    },
    pageDefaults () {
      return {
        loading: true,
        page: 1,
        page_size: 20,
        type: "MOST_RECENT",
        totalComments: 0, // fetched from server
      }
    },
    updateCommentsView () {
      let self = this;
      self.commentParams.page = 1;
      self.isCommentsComplete = false;
      self.$nextTick(function () {
        self.loadPostComments(self.postId);
      });
    },
    likeTopComment (comment_id, idx) {
      let self = this;
      const model = {
        post_id: self.postId,
        comment_id: comment_id,
        level: 0,
        index: idx,
      };
      LifeStyleApi.likePostComment(model);
    },
    likeSubComment (comment_id, sub_comment_id, parenti, idx) {
      let self = this;
      const model = {
        post_id: self.postId,
        parent_id: comment_id,
        comment_id: sub_comment_id,
        level: 1,
        parenti: parenti,
        index: idx,
      };
      LifeStyleApi.likePostComment(model);
    },
    addComment() {
      let self = this;
      let model = {
        comment: self.addCommentModel.message.trim(),
        post_id: self.postId,
        level: 0,
      };
      if( model.comment.length ) {
        self.isAddingComment = true;
        LifeStyleApi.addComment(model).then((response) => {
          if (response.data.complete) {
            self.isAddingComment = false;
            self.addCommentModel.message = '';
            self.$toastr.success('Success!');
          }
        });
      } else {
        self.$toastr.error('The comment field cannot be empty');
      }


      self.addCommentModel.message = '';
    },
    addSubComment(comment) {
      let self = this;
      if (comment.new_comment === "") {
        self.$toastr.error('Cannot have an empty comment');
        return;
      }
      let model = {
        comment: comment.new_comment.trim(),
        comment_id: comment.comment_id,
        post_id: self.postId,
        level: 1,
      };
      if (model.comment.length) {
        LifeStyleApi.addComment(model).then((response) => {
          if (response.data.complete) {
            comment.new_comment = '';
          }
        });
      }
    },
    editComment(level, index, parenti) {
      let self = this;
      if (level === 0) {
        self.comments[index].editcomment = true;
        self.comments[index].edit_comment = self.comments[index].comment;
      } else if (level === 1) {
        self.comments[parenti].replies[index].editcomment = true;
        self.comments[parenti].replies[index].edit_comment = self.comments[parenti].replies[index].comment;
      }
    },
    updateComment(level, comment, index, parenti) {
      let self = this;
      if (comment.edit_comment === "") {
        self.$toastr.error('Cannot have an empty comment');
        return;
      }
      const model = {
        post_id: self.postId,
        level: level,
        comment_id: level === 0 ? comment.comment_id : comment.sub_comment_id,
        comment: comment.edit_comment,
        parenti: parenti,
        index: index
      }
      LifeStyleApi.updateComment(model).then((res) => {
        if (res.data.complete) {
          self.closeReply(level, index, parenti);
        } else {
          alert('Sorry could not update comment');
        }
      });
    },
    closeReply(level, index, parenti) {
      let self = this;
      if (level === 0) {
        let comment = self.comments[index];
        comment.show = false;
        comment.editcomment = false;
        comment.edit_comment = comment.comment;
      } else if (level === 1) {
        let comment = self.comments[parenti];
        comment.replies[index].show = false;
        comment.replies[index].editcomment = false;
        comment.replies[index].edit_comment = comment.replies[index].comment;
      }
    },
    deleteComment(level, comment_id, index, parenti) {
      let self = this;
      const model = {
        post_id: self.postId,
        comment_id: comment_id,
        level: level,
        parenti: parenti,
        index: index,
      };
      self.$alert({
        title: "Are you sure?",
        text: "Are you sure you want to remove the following comment",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function () {
          return LifeStyleApi.deleteComment(model);
        }
      })
      .then(function (response) {
        self.$toastr.success('Comment successfully removed');
      }.bind(self))
      .catch(self.$alert.noop);
    },
    /*getCommentByIndex(index) {
      return _.find(self.comments, ['post_id', post_id]);
    },*/

  }
}



// WEBPACK FOOTER //
// ./src/components/LifeStyle/LifeComments/LifeCommentsMixin.js